import PropTypes from 'prop-types';
import LineChart from '../lineChart';

export const MIN_RANGE_VAXIS = 100; /* minimal cropping range of the vertical axis. */
export const PADDING_RANGE_VAXIS = 5; /* this values will be added to the min and max values */

/* SIZES CHART:
 **************************************************************************
 * LEGENDA *  WIDHT ONLY CHARTS                                           *
 * WIDTH   *                                                              *
 *         *                                                              *
 ************************************************************************* */

/**
 * Scatter
 * Display charts type Scatter
 * parameters (props)
 * @param string mode
 * @param array data = [{name, unit, data: [timestamp, val]}]
 * @param number width: chart's width including the size of the widthLegendeVaxis
 * @param number height: chart's height
 * @param number widthLegendeVaxis: legenda's height
 * @param number minDatetime: timestamp format: min value view port haxis
 * @param number maxDatetime: timestamp format: max value view port haxis
 */
export default class Scatter extends LineChart {
  cssName = 'digital-channels-chart-scatter';
  chartType = 'ScatterChart';
}

Scatter.propTypes = {
  mode: PropTypes.string,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      unit: PropTypes.string.isRequired,
      data: PropTypes.arrayOf(
        PropTypes.shape({
          timestamp: PropTypes.number.isRequired,
          val: PropTypes.number.isRequired,
        })
      ).isRequired,
    }).isRequired
  ).isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
  widthLegendeVaxis: PropTypes.number,
  minDatetime: PropTypes.number /* timestamp format */,
  maxDatetime: PropTypes.number /* timestamp format */,
  callBackZoom: PropTypes.func,
  language: PropTypes.string,
};

Scatter.defaultProps = {
  mode: null,
  width: null,
  height: null,
  widthLegendeVaxis: null,
  minDatetime: null,
  maxDatetime: null,
  callBackZoom: null,
  language: null,
  chartArea: {
    left: 0,
    top: 20, // legend
    bottom: 0,
    right: 0,
    width: '100%',
  },
  labels: {
    type: 'HTML',
    maxVAxis: 5,
    widthVAxis: undefined, // 60*5, if you define it, recommend use <maxVAxis> * 60, because each vAxis has 59px
  },
};
